// @flow
import type { RoamingStateType } from './Roaming/reducer';
import type { IDDStateType } from './IDD/reducer';
import type { TravelStateType } from './Travel/reducer';
import roamingReducer from './Roaming';
import iddReducer from './IDD';
import travelReducer from './Travel';
import { combineReducers } from 'redux';

export type InternationalStateType = {|
  roaming?: RoamingStateType,
  idd?: IDDStateType,
  travel?: TravelStateType,
|};

export default combineReducers({
  roaming: roamingReducer,
  idd: iddReducer,
  travel: travelReducer,
});
